import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { fade } from '@material-ui/core/styles/colorManipulator';
import api from '../api/backend'
import moment from 'moment'

import video1 from '../assets/img/video1.png'

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    icon: {
        marginRight: theme.spacing.unit * 2,
    },
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class MyCoursePage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { myCourses: [], loading: false }
    }

    isAdmin = () => {
        const user = JSON.parse(sessionStorage.getItem('user'))
        return user && user.userName === 'admin'
    }

    getMyCourse = () => {
        this.setState({ loading: true })
        const request = this.isAdmin() ? api.getCourses() : api.getMyCourse()
        request.then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ myCourses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        }).finally(() => {
            this.setState({ loading: false })
        })
    }

    findCourse = () => {
        const { term } = this.state
        this.setState({ loading: true })
        const request = this.isAdmin() ? api.searchCourse(term) : api.searchMyCourse(null, term)
        request.then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ myCourses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        }).finally(() => {
            this.setState({ loading: false })
        })
    }


    componentDidMount() {
        this.getMyCourse()
    }

    render() {
        const { classes } = this.props
        const { myCourses, loading } = this.state
        return (
            <main style={{ paddingTop: 64 }}>
                {/* Hero unit */}
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            คอร์สเรียน
            </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.findCourse()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                {loading && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 0' }}>
                        <CircularProgress size={80} thickness={4} />
                        <Typography variant="title" color="textSecondary" style={{ marginTop: 24 }}>
                            กำลังโหลด...
                        </Typography>
                    </div>
                )}
                <div className={classNames(classes.layout, classes.cardGrid)} style={{ display: loading ? 'none' : 'block' }}>
                    {/* End hero unit */}
                    <Grid container spacing={40}>
                        {myCourses.map(course => (
                            <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                    <Card className={classes.card}>
                                        <CardActionArea >
                                            <CardHeader
                                                avatar={
                                                    <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={video1} />
                                                }
                                                // title={course.course.title}
                                                title={<Typography style={{ height: 48}} variant="subheading">
                                                {course.course.title}
                                            </Typography>}
                                                subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                            />
                                            <CardMedia
                                                className={classes.cardMedia}
                                                image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                title="Image title"
                                            />
                                            <CardContent className={classes.cardContent}>
                                                <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                    {course.course.description}
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Link>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </main>
        );
    }
}

export default withStyles(styles)(MyCoursePage);